import { Chart } from 'react-google-charts';
import React from 'react';
import useFetchData from '../../../hooks/useFetchData';
import { formatChartAmount, readTenantChartTheme } from '../../../saas/chartTheme';

const ProfitExpenseNett = () => {
  const { items: expenses } = useFetchData('https://servers.thakurgaonexpress.com/rupkotha/monthwiseexpenseincome');
  const { items: profit } = useFetchData('https://servers.thakurgaonexpress.com/rupkotha/daywiseprofit');
  const safeExpenses = Array.isArray(expenses) ? expenses : [];
  const safeProfit = Array.isArray(profit) ? profit : [];
  const totalProfit = safeProfit.reduce((total, item) => total + (Number(item?.profit) || 0), 0);
  const totalExpense = safeExpenses.reduce((total, item) => total + (Number(item?.thismonthexpense) || 0), 0);
  const totalIncome = safeExpenses.reduce((total, item) => total + (Number(item?.thismonthincome) || 0), 0);
  const netProfit = totalProfit + totalIncome - totalExpense;
  const theme = readTenantChartTheme();
  const data = [['Task', 'Amount'], ['Profit', netProfit], ['Expense', totalExpense]];
  const options = { backgroundColor: 'transparent', colors: [theme.primary, theme.danger], pieHole: 0.62, pieSliceText: 'none', legend: { position: 'bottom', textStyle: { color: theme.muted, fontSize: 11 } }, chartArea: { width: '82%', height: '73%', top: 14 }, tooltip: { textStyle: { color: theme.text } } };

  return <section className="trend-chart trend-chart--pie"><div className="trend-chart__heading"><div><small>Current month</small><h3>Profit vs Expense</h3></div><strong>৳ {formatChartAmount(netProfit)}</strong></div><Chart chartType="PieChart" data={data} options={options} width="100%" height="270px" /></section>;
};

export default ProfitExpenseNett;
